/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} This_Quick_Fly_GulpInputs */

const fr_this_quick_fly_gulp = /** @type {(inputs: This_Quick_Fly_GulpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter`)
};

/**

* @param {This_Quick_Fly_GulpInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const this_quick_fly_gulp = /** @type {((inputs?: This_Quick_Fly_GulpInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<This_Quick_Fly_GulpInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_this_quick_fly_gulp(inputs)
});